import DOMPurify from 'dompurify';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import ReactMarkdown from 'react-markdown';

type DOMPurifyConfig = Parameters<typeof DOMPurify.sanitize>[1];

// Regex for URIs allowed by DOMPurify by default (https://github.com/cure53/DOMPurify#control-permitted-attribute-values)
// Only used by callers to MarkdownContent implemented before newer security options were added
// If new callers want to allow URIs, please use /^https:/ instead
export const DANGEROUS_LEGACY_ALLOWED_URI_REGEXP =
  // eslint-disable-next-line no-useless-escape
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;

interface MarkdownContentProps {
  content: string;
  // These options should not be overriden without Security approval
  dangerousSecurityOptions?: {
    // By default style tags and attributes aren't allowed
    blockStyle?: boolean;
    // By default uris aren't allowed
    allowedUris?: RegExp;
  };
}

/**
 * Renders the provided content as markdown.
 */
export default function MarkdownContent({
  content,
  dangerousSecurityOptions,
}: MarkdownContentProps): JSX.Element {
  const renderedMarkdown = ReactDOMServer.renderToStaticMarkup(<ReactMarkdown>{content}</ReactMarkdown>);

  const options: DOMPurifyConfig = {ALLOWED_URI_REGEXP: dangerousSecurityOptions?.allowedUris ?? /^$/};
  if (dangerousSecurityOptions?.blockStyle ?? true) {
    options.FORBID_TAGS = ['style'];
    options.FORBID_ATTR = ['style'];
  }
  const sanitizedMarkdown = DOMPurify.sanitize(renderedMarkdown, options);

  // oxlint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{__html: sanitizedMarkdown}} />;
}
